import script from "./VideosDetailsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideosDetailsView.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30899558"]])

export default __exports__